import { render, staticRenderFns } from "./cwts_details.vue?vue&type=template&id=650a900b&"
import script from "./cwts_details.vue?vue&type=script&lang=js&"
export * from "./cwts_details.vue?vue&type=script&lang=js&"
import style0 from "./cwts_details.vue?vue&type=style&index=0&id=650a900b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports